import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import {fetchCampaignSuccess, fetchCampaignError, addCampaignSuccess, addCampaignError, updateCampaignSuccess, updateCampaignError, deleteCampaignSuccess, deleteCampaignError} from '../actions/Campaign';
import { getDocs, addDoc, updateDoc, deleteDoc } from 'firebase/services/campaign';
import {FETCH_CAMPAIGN, ADD_CAMPAIGN, UPDATE_CAMPAIGN, DELETE_CAMPAIGN} from 'constants/ActionTypes';

function* fetchCampaignRequest({ params }) {
  try {
    const fetchedCampaignList = yield call(getDocs, { filter: params && params.filter });
    yield put(fetchCampaignSuccess(fetchedCampaignList));
  } catch (error) {
    console.log(error);
    yield put(fetchCampaignError(error));
  }
}

function* addCampaignRequest({ payload: { params } }) {
  try {
    const requests = params.map(param => call(addDoc, {data: param}));
    const result = yield all(requests);
    yield put(addCampaignSuccess(result));
  } catch (error) {
    console.log(error);
    yield put(addCampaignError(error));
  }
}

function* updateCampaignRequest({ payload: { params } }) {
  try {
    const result = yield call(updateDoc, {data: params});
    yield put(updateCampaignSuccess(result));
  } catch (error) {
    console.log(error);
    yield put(updateCampaignError(error));
  }
}

function* deleteCampaignRequest({ payload: { params } }) {
  try {
    yield call(deleteDoc, {id: params});
    yield put(deleteCampaignSuccess({ id: params }));
  } catch (error) {
    console.log(error);
    yield put(deleteCampaignError(error));
  }
}

export function* fetchCampaign() {
  yield takeEvery(FETCH_CAMPAIGN, fetchCampaignRequest);
}

export function* addCampaign() {
  yield takeEvery(ADD_CAMPAIGN, addCampaignRequest);
}

export function* updateCampaign() {
  yield takeEvery(UPDATE_CAMPAIGN, updateCampaignRequest);
}

export function* deleteCampaign() {
  yield takeEvery(DELETE_CAMPAIGN, deleteCampaignRequest);
}

export default function* rootSaga() {
  yield all([fork(fetchCampaign), fork(addCampaign), fork(updateCampaign), fork(deleteCampaign)]);
}
